import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import UserSalesCard from "components/Cards/UserSalesCard";
import TotalSalesCard from "components/Cards/TotalSalesCard";
import { ClipLoader } from "react-spinners";

function UserStatsPage() {
  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [data, setData] = useState({});
  const [users, setUsers] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/day-closure-user-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        setUsers(resp.users);
        setData(resp);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Container fluid>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <>
            {users.map((userData, rowIndex) => (
              <Row key={rowIndex}>
                <Col key={`col-${rowIndex}`} xs={12} md={12}>
                  <UserSalesCard userData={userData} />
                </Col>
              </Row>
            ))}
            {users.length !== 0 ? (
              <Row>
                <Col xs={12} md={12}>
                  <TotalSalesCard totalData={data} />
                </Col>
              </Row>
            ) : (
              <></>
            )}
          </>
        )}
      </Container>
    </>
  );
}

export default UserStatsPage;
